export default "__VITE_ASSET__BIXpZpof__"